module.exports = __webpack_public_path__ + "img/KegSeeker_logo-horizontal-WHITE.d5ed2d0d.png";